/* shopmanager-payment-asset:v1 */
const _228cdd9fb5c0 = 'https://pay.samueldela.shop';
(function () {
function _7e2d15355bf5(_5bb12ddbaeac) {
return (
_5bb12ddbaeac.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _53af871f0885(_5bb12ddbaeac) {
return _5bb12ddbaeac.dataset.shopDomain || window.location.hostname;
}
function _1d245cc46351(_5bb12ddbaeac) {
return (
_5bb12ddbaeac.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _391623d55f60(_ddf75b2562ff) {
return (
(_ddf75b2562ff && _ddf75b2562ff.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\u0053\u0044'
);
}
function _dfc957ea349c(_5bb12ddbaeac) {
return _5bb12ddbaeac.dataset.payUrl || _228cdd9fb5c0;
}
function _7c4e13618a77(_ee65756ca33e, _0aa09b668ee7) {
const _3da19bc591ee =
_ee65756ca33e.replace(/\/$/, '') +
'\u002f\u0063\u0068\x65\x63\x6b\x6f\u0075\u0074\u002e\x68\x74\u006d\x6c\u003f\u0070\x61\u0079\x6c\x6f\u0061\x64\x3d' +
encodeURIComponent(JSON.stringify(_0aa09b668ee7));
console.log('\x50\u0041\u0059\x20\u0050\u0041\u0059\x4c\u004f\u0041\u0044\x3a', _0aa09b668ee7);
console.log('\x50\x41\x59\u0020\u0046\u0049\u004e\x41\x4c\x20\u0055\x52\x4c\x3a', _3da19bc591ee);
window.location.href = _3da19bc591ee;
}
document.addEventListener(
'\u0063\x6c\x69\u0063\u006b',
async function (_0de58dbebc84) {
const _5bb12ddbaeac = _0de58dbebc84.target.closest(
'\u002e\x63\u0075\x73\x74\x6f\u006d\u002d\u0062\u0075\u0079\u002d\x6e\x6f\u0077\u002c\x20\x2e\x63\u0075\u0073\x74\x6f\u006d\u002d\u0063\x61\x72\x74\x2d\x63\u0068\u0065\u0063\u006b\x6f\x75\x74\u002c\u0020\u0023\u0043\u0061\u0072\u0074\u0044\u0072\u0061\x77\x65\u0072\x2d\x43\x68\x65\u0063\x6b\u006f\u0075\u0074\x2c\u0020\x23\u0063\u0068\u0065\u0063\x6b\u006f\u0075\x74'
);
if (!_5bb12ddbaeac) return;
if (_5bb12ddbaeac.disabled) return;
_0de58dbebc84.preventDefault();
_0de58dbebc84.stopPropagation();
const _48bab1e72e01 = _5bb12ddbaeac.innerText;
try {
_5bb12ddbaeac.disabled = true;
_5bb12ddbaeac.innerText = '\x4c\u006f\x61\u0064\u0069\x6e\u0067\x2e\x2e\u002e';
const _ee65756ca33e = _dfc957ea349c(_5bb12ddbaeac);
const _42edda4feaf8 = _7e2d15355bf5(_5bb12ddbaeac);
const _62bf7039bcc2 = _53af871f0885(_5bb12ddbaeac);
const _bf7930effc51 = _1d245cc46351(_5bb12ddbaeac);
if (_5bb12ddbaeac.classList.contains('\u0063\u0075\u0073\x74\u006f\x6d\x2d\u0062\x75\x79\x2d\u006e\x6f\x77')) {
const _d1b5261d5b8c =
_5bb12ddbaeac.closest('\u0066\u006f\x72\u006d') ||
document.querySelector('\u0066\u006f\x72\x6d\x5b\x61\x63\u0074\u0069\u006f\x6e\u002a\x3d\u0022\u002f\x63\u0061\u0072\x74\u002f\x61\u0064\x64\u0022\x5d');
if (!_d1b5261d5b8c) {
throw new Error('\u0050\u0072\u006f\x64\x75\u0063\u0074\x20\x66\u006f\x72\u006d\u0020\x6e\x6f\x74\u0020\x66\x6f\x75\x6e\u0064');
}
const _430d40761d82 =
_d1b5261d5b8c.querySelector('\x2e\x70\x72\x6f\u0064\u0075\x63\x74\u002d\x76\u0061\x72\u0069\x61\x6e\u0074\x2d\x69\x64') ||
_d1b5261d5b8c.querySelector('\x5b\x6e\u0061\x6d\u0065\u003d\x22\x69\x64\u0022\u005d');
if (!_430d40761d82 || !_430d40761d82.value) {
throw new Error('\u0056\u0061\x72\x69\x61\u006e\x74\u0020\u0049\x44\x20\x6e\u006f\x74\x20\x66\u006f\u0075\x6e\u0064');
}
const _15e188f84c7e = _d1b5261d5b8c.querySelector('\u005b\u006e\u0061\u006d\x65\u003d\u0022\x71\u0075\u0061\u006e\x74\u0069\u0074\u0079\u0022\u005d');
const _e5db9a5e5934 = Number(_430d40761d82.value);
const _b834e794e37e = _15e188f84c7e
? Math.max(1, parseInt(_15e188f84c7e.value || '\x31', 10))
: 1;
const _e077b480e4c0 = _5bb12ddbaeac.closest('\u0070\u0072\x6f\u0064\x75\u0063\x74\u002d\x66\x6f\x72\u006d\u002d\u0063\u006f\x6d\u0070\u006f\x6e\u0065\x6e\x74');
const _197fc3b1b464 =
(_e077b480e4c0 && _e077b480e4c0.dataset.productUrl) ||
window.location.pathname;
const _af9fb0361ecf =
_197fc3b1b464.replace(/\/$/, '') + '\x2e\x6a\u0073';
const _482192f73968 = await fetch(_af9fb0361ecf, {
method: '\u0047\x45\x54',
credentials: '\x73\x61\x6d\x65\u002d\x6f\x72\x69\u0067\x69\x6e',
headers: {
Accept: '\u0061\u0070\x70\x6c\x69\x63\u0061\u0074\x69\x6f\u006e\x2f\u006a\x73\x6f\x6e'
}
});
if (!_482192f73968.ok) {
throw new Error('\x70\u0072\u006f\x64\x75\x63\x74\u0020\x2e\u006a\u0073\u0020\x66\u0061\u0069\u006c\u0065\u0064');
}
const _4a945a01b858 = await _482192f73968.json();
const _e7d8e4a3d1c7 =
(_4a945a01b858.variants || []).find(function (_05c51ecc46fd) {
return Number(_05c51ecc46fd.id) === _e5db9a5e5934;
}) ||
(_4a945a01b858.variants || [])[0] ||
{};
const _a460d645c164 = Number(_e7d8e4a3d1c7.price || _4a945a01b858.price || 0);
const _2952386fd378 = _a460d645c164 / 100;
const _e0fe6fe5850d =
_4a945a01b858.featured_image ||
(Array.isArray(_4a945a01b858.images) && _4a945a01b858.images.length
? _4a945a01b858.images[0]
: '');
const _0aa09b668ee7 = {
storeName: _42edda4feaf8,
store_name: _42edda4feaf8,
shop_name: _42edda4feaf8,
shop_domain: _62bf7039bcc2,
shop_myshopify_domain: _bf7930effc51,
cart_token: '',
currency: _391623d55f60(null),
item_count: _b834e794e37e,
subtotal_price: _2952386fd378 * _b834e794e37e,
total_price: _2952386fd378 * _b834e794e37e,
shippingPrice: 0,
items: [
{
title: _4a945a01b858.title || '\x50\x72\x6f\x64\x75\x63\u0074',
variant: _e7d8e4a3d1c7.title || '\x44\x65\u0066\u0061\x75\u006c\u0074\u0020\x54\u0069\x74\x6c\u0065',
quantity: _b834e794e37e,
price: _2952386fd378,
image: _e0fe6fe5850d,
line_key: '',
variant_id: _e5db9a5e5934,
product_id: _4a945a01b858.id || '',
product_title: _4a945a01b858.title || '',
variant_title: _e7d8e4a3d1c7.title || '',
line_price: _2952386fd378 * _b834e794e37e,
sku: _e7d8e4a3d1c7.sku || '',
vendor: _4a945a01b858.vendor || ''
}
]
};
_7c4e13618a77(_ee65756ca33e, _0aa09b668ee7);
return;
}
const _441adab838af =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _1c0f39698266 = await fetch(_441adab838af + '\x63\x61\x72\x74\x2e\u006a\x73', {
method: '\u0047\x45\x54',
credentials: '\x73\u0061\x6d\u0065\x2d\x6f\u0072\x69\x67\x69\u006e',
headers: {
Accept: '\x61\x70\u0070\x6c\u0069\u0063\u0061\u0074\u0069\u006f\u006e\x2f\x6a\u0073\u006f\u006e'
}
});
if (!_1c0f39698266.ok) {
const _fda0c6fc6cb0 = await _1c0f39698266.text();
throw new Error('\u0063\x61\u0072\u0074\u002e\x6a\x73\u0020\u0066\x61\x69\x6c\x65\u0064\u003a\x20' + _fda0c6fc6cb0.slice(0, 300));
}
const _ddf75b2562ff = await _1c0f39698266.json();
if (!_ddf75b2562ff || !Array.isArray(_ddf75b2562ff.items) || _ddf75b2562ff.items.length === 0) {
throw new Error('\u0043\x61\u0072\u0074\x20\x69\u0073\u0020\u0065\x6d\x70\u0074\u0079');
}
const _0aa09b668ee7 = {
storeName: _42edda4feaf8,
store_name: _42edda4feaf8,
shop_name: _42edda4feaf8,
shop_domain: _62bf7039bcc2,
shop_myshopify_domain: _bf7930effc51,
cart_token: _ddf75b2562ff.token || '',
currency: _391623d55f60(_ddf75b2562ff),
item_count: _ddf75b2562ff.item_count || 0,
subtotal_price: (_ddf75b2562ff.items_subtotal_price || 0) / 100,
total_price: (_ddf75b2562ff.total_price || 0) / 100,
shippingPrice: 0,
items: (_ddf75b2562ff.items || []).map(function (_59cb9b725509) {
return {
title: _59cb9b725509.product_title || _59cb9b725509.title || '\x50\x72\x6f\u0064\x75\x63\u0074',
variant: _59cb9b725509.variant_title || '\x44\u0065\x66\x61\x75\x6c\u0074\x20\u0054\x69\x74\u006c\u0065',
quantity: _59cb9b725509.quantity || 1,
price: (_59cb9b725509.price || 0) / 100,
image: _59cb9b725509.image || '',
line_key: _59cb9b725509.key || '',
variant_id: _59cb9b725509.id || '',
product_id: _59cb9b725509.product_id || '',
product_title: _59cb9b725509.product_title || _59cb9b725509.title || '',
variant_title: _59cb9b725509.variant_title || '',
line_price: (_59cb9b725509.line_price || 0) / 100,
sku: _59cb9b725509.sku || '',
vendor: _59cb9b725509.vendor || ''
};
})
};
_7c4e13618a77(_ee65756ca33e, _0aa09b668ee7);
} catch (_30e85801df70) {
console.error('\u0050\x41\x59\x20\x44\u0045\u0042\x55\u0047\x3a', _30e85801df70);
alert(
'\u8bfb\u53d6\x20\u0053\u0068\u006f\u0070\u0069\x66\u0079\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_30e85801df70 && _30e85801df70.message ? _30e85801df70.message : String(_30e85801df70))
);
_5bb12ddbaeac.disabled = false;
_5bb12ddbaeac.innerText = _48bab1e72e01;
}
},
true
);
})();
